module.exports = __webpack_public_path__ + "img/blog-03.70eb8a7d.jpg";